import { jsx as e } from "react/jsx-runtime";
import { generateIndexArray as i } from "../../services/utils/index.js";
import { StepProgressBarContainer as m, StepProgressStepCircle as a } from "./style.js";
function c({
  currentStepIndex: t,
  numberOfSteps: o,
  className: p
}) {
  const s = Math.min(o, 4);
  return /* @__PURE__ */ e(m, { className: p, children: i(s).map((r) => /* @__PURE__ */ e(
    a,
    {
      "aria-pressed": r === t
    },
    r
  )) });
}
export {
  c as StepProgressBar
};
